var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,attrs:{"disabled":_vm.ui.instance.processing},on:{"click":_vm.createInstance}},[(_vm.ui.instance.saving)?[_c('loading-spinner',{attrs:{"size":"1x"}})]:[_vm._t("default",function(){return [_vm._v("Start now")]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }